import { subscriptionPreOrderDeliveryProfileSettingsSchema } from "@redotech/redo-conversion-core-common/checkouts/subscription-pre-order-delivery-profile";
import * as z from "zod";

export const updateSubscriptionPreOrderDeliveryProfileSettings = {
  name: "updateSubscriptionPreOrderDeliveryProfileSettings" as const,
  input: z.object({
    settings: subscriptionPreOrderDeliveryProfileSettingsSchema.omit({
      deliveryProfileId: true,
    }),
  }),
  output: z.null(),
};
